// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"stat-menu_contextMenu_3kxAH","link":"stat-menu_link_24RTP"};